import styled from "styled-components";

export const ToolbarRegion = styled.div`
  background-color: var(--ons-color-grey-5);
  border: 1px solid var(--ons-color-black);
  border-radius: 4px 4px 0 0;
  padding: 0 9px;

  &:focus-within {
    outline: 2px solid var(--ons-color-sun-yellow);
    outline-offset: 0px;
  }
`;

export const ToolbarItems = styled.div`
  display: flex;
  align-items: stretch;
  flex-wrap: wrap;
`;

export const ToolbarDivider = styled.span`
  width: 1px;
  margin: 9px 9px;
  background-color: var(--ons-color-grey-35);
`;

export const ToolbarButton = styled.button<{ $active?: boolean }>`
  min-width: 54px;
  height: 48px;
  border: 0;
  padding: 7px 9px;
  margin: 0;
  background: transparent;
  color: var(--ons-color-grey-100);
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;

  ${(properties) =>
    properties.$active
      ? `
    background-color: var(--ons-color-grey-15);
    color: var(--ons-color-black);
  `
      : ""};

  &:not(:disabled):hover {
    background-color: var(--ons-color-grey-15);
  }

  &:not(:disabled):focus-visible {
    outline: none;
    /* Top and bottom 1px to avoid stacking with toolbar's own border */
    box-shadow:
      inset 2px 0 0 0 var(--ons-color-black),
      inset -2px 0 0 0 var(--ons-color-black),
      inset 0 1px 0 0 var(--ons-color-black),
      inset 0 -1px 0 0 var(--ons-color-black);
    background-color: var(--ons-color-sun-yellow);
    color: var(--ons-color-black);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ToolbarIcon = styled.span`
  display: block;
  line-height: 1;
  font-size: 0.875rem;
  min-height: 12px;
  margin-bottom: 7px;

  .ons-icon {
    height: 18px;
    width: 18px;
    padding-bottom: 3px;
  }
`;

export const ToolbarText = styled.span`
  font-size: 0.8rem;
  line-height: 1;
`;
